import { centralDateOf, centralToday } from './centralDate';

/** Days between a YYYY-MM-DD (or ISO) date and today (America/Chicago calendar days). */
export function daysSinceDate(dateStr: string | null | undefined, now = new Date()): number | null {
  if (dateStr == null || dateStr === '') return null;
  const raw = String(dateStr).trim();
  const day = /^\d{4}-\d{2}-\d{2}/.test(raw) && !/T\d{2}:/.test(raw) ? raw.slice(0, 10) : centralDateOf(raw);
  if (!day) return null;
  const [sy, sm, sd] = day.split('-').map(Number);
  const [ty, tm, td] = centralToday(now).split('-').map(Number);
  const start = Date.UTC(sy, sm - 1, sd);
  const today = Date.UTC(ty, tm - 1, td);
  return Math.floor((today - start) / 86400000);
}

export function formatLastTransactionLabel(
  dateStr: string | null | undefined,
  now = new Date()
): string {
  if (!dateStr) return 'N/A';
  const days = daysSinceDate(dateStr, now);
  if (days == null) return String(dateStr);
  if (days === 0) return `${dateStr} (today)`;
  if (days === 1) return `${dateStr} (1 day)`;
  return `${dateStr} (${days} days)`;
}

export const KEG_OLDER_THAN_OPTIONS = [30, 60, 90, 180] as const;
